export enum StepGuardEnum {
  personalData = 0,
  documentsPending = 1,
  prepaymentPending = 2,
  confirmationPending = 3,
  regNotValid = 4,
  paymentPending = 5,
  resultPending = 6
}
